// GA4 (gtag) for the web app. No-ops cleanly when the measurement id is unset,
// so dev/preview/test builds send zero analytics traffic.
const measurementId = (process.env.REACT_APP_GA4_MEASUREMENT_ID || '').trim();
let ready = false;

export function initWebAnalytics() {
  if (!measurementId || typeof window === 'undefined') return false;
  if (ready) return true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  // Manual SPA pageviews below; suppress the automatic initial one.
  window.gtag('config', measurementId, { send_page_view: false });
  ready = true;
  return true;
}

export function pageView({ path, title } = {}) {
  if (!ready || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_title: title || document.title,
    page_location: `${window.location.origin}${path || window.location.pathname}`,
    page_path: path || window.location.pathname,
  });
}

export function trackEvent(name, params = {}) {
  if (!ready || !window.gtag || !name) return;
  window.gtag('event', name, params);
}
